// Phase 6.0 · 축소 카테고리 chip 스트립 (관리자 카테고리 확장 가능 · 하드코딩 없음)
import React from 'react';
import { Link } from 'react-router-dom';

const ICONS = {
  fashion: '👗', beauty: '💄', food: '🍔', living: '🛋️', pet: '🐾', kids: '🧸',
  electronics: '📱', home: '🏠', health: '💊', sports: '⚽', others: '🏷️',
};

export default function SmallCategoryStrip({ categories }) {
  if (!categories?.length) return null;
  return (
    <section className="border-b border-black/5 dark:border-white/10 bg-white/60 dark:bg-white/[0.02]" data-testid="home-category-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 sm:py-2.5">
        <div className="flex items-center gap-1.5 sm:gap-2 overflow-x-auto snap-x scroll-smooth
          [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
          {categories.map((c) => (
            <Link
              key={c.category_id || c.slug}
              to={`/search?category=${encodeURIComponent(c.slug)}`}
              className="snap-start shrink-0 inline-flex items-center gap-1 px-2.5 py-1 rounded-full
                bg-white dark:bg-[#141414] border border-black/10 dark:border-white/10
                text-[11px] sm:text-xs font-bold text-gray-700 dark:text-gray-200
                hover:border-[#FF3B30] hover:text-[#FF3B30] transition-colors"
              data-testid={`cat-chip-${c.slug}`}>
              <span className="text-sm leading-none">{ICONS[c.slug] || '🏷️'}</span>
              <span>{c.name || c.slug}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
